import Vue from 'vue';
import {Orion} from '@tailflow/laravel-orion/lib/orion';
import ResortGuide from '../ResortGuide';

var config = window.config || {
    url: window.location.origin,
    site: 1,
};

Orion.init(config.url, 'sapi');
Orion.setToken('access-token-here');

var mountElement = document.getElementById('resort-guide-app');

if (mountElement) {
    new Vue({
        el: mountElement,
        components: {
            'resort-guide': ResortGuide,
        },
        data: function ()
        {
            return {
                config: config,
            };
        },
    });
}
